var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 559.36 207.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calis") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.71,203.15Q23,186,19.69,168q-4.55-24.33-8-47.5A6.44,6.44,0,0,1,8,126.19a6.17,6.17,0,0,1-4.83,0A6.29,6.29,0,0,1,1,124.41c-2.27-3.07-.29-8.7,1.12-13.2s2.05-9.54,3.68-14.12C8.5,89.6,15.42,64.55,31,2.65A3.27,3.27,0,0,1,32.27.53a3.4,3.4,0,0,1,3.81.12,3.75,3.75,0,0,1,1.38,1.81l.06,56.69a3.91,3.91,0,0,1-7.25-.5L29.9,44.07q-1.09,3.28-2.13,6.66A346.25,346.25,0,0,0,18,90.78q3.12,18.56,6.13,37.37,5.94,37.22,11.15,73.68a4.57,4.57,0,0,1-2.9,4.76A4.62,4.62,0,0,1,26.71,203.15Z",
    fill: "#c31c37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.69,203.68q3.66-17.16,7-35.12,4.55-24.31,8-47.5a6.47,6.47,0,0,0,3.63,5.67,6.22,6.22,0,0,0,4.83,0,6.39,6.39,0,0,0,2.16-1.79c2.27-3.07.29-8.7-1.12-13.19-1.44-4.65-2-9.55-3.68-14.13C83.9,90.13,77,65.08,61.38,3.18a3.29,3.29,0,0,0-1.25-2.12,3.44,3.44,0,0,0-3.81.12A3.72,3.72,0,0,0,54.94,3l-.06,56.68a3.91,3.91,0,0,0,7.25-.5L62.5,44.6q1.09,3.3,2.13,6.67a346.1,346.1,0,0,1,9.75,40q-3.12,18.57-6.13,37.37-5.94,37.23-11.15,73.69a4.55,4.55,0,0,0,2.9,4.75A4.62,4.62,0,0,0,65.69,203.68Z",
    fill: "#c31c37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "NOMBRE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152,61.41,143.1,76H118.45Q115.71,91.4,113,106.8h31.13q-4.52,7.14-9,14.29c-10.85,0-19.6.06-27.54.22-2.61,0-6.4.14-8.9-2.37s-2.79-6.18-1.83-12.16c2.63-16.38,2.55-16.27,5.33-33.09.57-3.39,1.17-7.35,4.35-9.92,2.92-2.37,6.54-2.37,8.2-2.37C122.89,61.4,135.77,61.3,152,61.41Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.19,62.44h19.08q5.13,29.34,10.25,58.67l-37.75,0q3.6-7.15,7.19-14.3l7.87,0q-.12-10.55-.25-21.1-3.21,7.17-6.87,14.63-5.37,10.91-10.85,20.75H139.93Q155,91.77,170.19,62.44Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.69,61.41h17.5q-4.26,22.7-8.5,45.39h22.54q2.55,7.15,5.09,14.29l-44.84,0Q205.59,91.24,209.69,61.41Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.33,61.41H274q-4.83,29.85-9.65,59.68H248.58Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.69,121.09l2.25-14.29h26.75a25.71,25.71,0,0,0,.71-2.52,23.49,23.49,0,0,0,.5-6.13l-18.25.13A6.92,6.92,0,0,1,274.4,97a7.63,7.63,0,0,1-2.55-7.73q1.63-9.89,3.25-19.79a9.78,9.78,0,0,1,8.3-8H319L312.44,76h-23l-.75,9.25,19.46.17a5.09,5.09,0,0,1,3.25,1.38,5.4,5.4,0,0,1,1.4,4.58q-.93,9.87-1.84,19.73c0,.57.06,5.48-3.75,8.31a9.12,9.12,0,0,1-4.38,1.69Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.31,76h-14.5l2.13-14.57h43.62Q363,68.7,361.4,76H347.94q-4.05,22.56-8.09,45.11H325.52Q329.42,98.53,333.31,76Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.15,61.41h37.62L403.46,76H379.77l-1.31,8.3,23.83-.15-2.52,13.33H376.15c-.55,3.15-1.09,6.29-1.63,9.44l23.5-.1-2.19,14.29H357.15Q362.64,91.26,368.15,61.41Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.27,121.09H429.4q4.05-22.56,8.12-45.11a50.94,50.94,0,0,0-6.5-.37,50.27,50.27,0,0,0-5.81.37q-3.94,22.56-7.9,45.11H401.52l10.71-59.68H443.1c4.56-.26,8.6,1.76,10.21,5.12a8.49,8.49,0,0,1,.67,4.91Q449.63,96.26,445.27,121.09Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.24,61.41h15.69q-5,29.85-9.92,59.68H450.22Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.74,62.42h19.08q5.13,29.34,10.25,58.67l-37.75,0q3.6-7.16,7.19-14.3l7.87,0q-.12-10.55-.25-21.1-3.22,7.17-6.87,14.63-5.37,10.91-10.85,20.75H467.48Q482.6,91.75,497.74,62.42Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.06,127.11h15.68q-4.81,29.83-9.65,59.67H226.3Q231.18,156.95,236.06,127.11Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.76,127.11h15.69l-9.66,59.67H304Q308.88,156.95,313.76,127.11Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.6,128.19h19.08q5.13,29.34,10.25,58.67l-37.75,0q3.6-7.16,7.19-14.3l7.87,0q-.12-10.55-.25-21.1-3.23,7.17-6.87,14.63-5.37,10.91-10.85,20.75H320.34Q335.46,157.51,350.6,128.19Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.27,127.69h17.5q-4.25,22.69-8.5,45.39h22.54l5.09,14.28-44.84,0Q183.17,157.52,187.27,127.69Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.17,186.86H263.09q-4.72-29.93-9.44-59.83h16.68q2.73,18.27,5.44,36.56,3.28-7.22,6.88-14.63,5.53-11.4,11.18-21.93h18.44Q297.23,156.94,282.17,186.86Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.3,127.61q-4.29,29.92-8.59,59.84H174.8q3.58-29.92,7.16-59.84Zm21.08,44.59L149,172q2-16.54,4.09-33.08h10Q161.2,155.57,159.38,172.2Z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.52,156.27c8.34-8.49,11.11-18.64,7.4-24.77a11.86,11.86,0,0,0-5.15-4.48H90.86q-4.39,29.92-8.77,59.84h36.85c8.68-9,12.41-19.47,8.9-26.5A12.56,12.56,0,0,0,124.52,156.27Zm-10.43,10.07a17.14,17.14,0,0,1-1.5,4.18,17.62,17.62,0,0,1-2.75,3.88l-11.38.06a78,78,0,0,1,.5-8.81c.22-1.9.5-3.69.81-5.38l11.63.19a7,7,0,0,1,1.81,2.13A7.25,7.25,0,0,1,114.09,166.34Zm3-18.88a27.37,27.37,0,0,1-3.88,5.5,54.6,54.6,0,0,1-5.5.25,53.79,53.79,0,0,1-6-.37,46.53,46.53,0,0,1,.06-6.32,47,47,0,0,1,1.25-7.68l11.13.18a10.93,10.93,0,0,1,1.75,1.67,10.41,10.41,0,0,1,1.31,2,7.84,7.84,0,0,1-.12,4.75Z",
    fill: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SWO"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.25,159.09l.9-5.76H459a10.07,10.07,0,0,0,.28-1,9,9,0,0,0,.2-2.47l-7.37,0a2.75,2.75,0,0,1-1.71-.53,3.08,3.08,0,0,1-1-3.12c.44-2.66.88-5.33,1.31-8a4,4,0,0,1,1.17-2.19A4,4,0,0,1,454,135h14.37l-2.64,5.88h-9.29l-.3,3.74,7.86.06a2.05,2.05,0,0,1,1.31.56,2.15,2.15,0,0,1,.56,1.85c-.24,2.66-.49,5.31-.74,8a4.17,4.17,0,0,1-1.51,3.35,3.64,3.64,0,0,1-1.77.68Z",
    fill: "#9b9c9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.2,140.88h-5.85c.28-2,.57-3.92.85-5.88h17.62c-.43,2-.85,3.92-1.28,5.88h-5.43l-3.27,18.21h-5.78Q471.62,150,473.2,140.88Z",
    fill: "#9b9c9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.7,135.05h15.19c-.31,2-.63,3.92-.94,5.88h-9.56l-.53,3.35,9.62-.06-1,5.38h-9.53l-.66,3.81,9.49,0c-.3,1.93-.59,3.85-.89,5.77H502.25Z",
    fill: "#9b9c9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.39,135.05h15.2q-.48,2.94-.94,5.88h-9.56l-.53,3.35,9.62-.06-1,5.38h-9.54l-.65,3.81,9.49,0c-.3,1.93-.59,3.85-.89,5.77H520Z",
    fill: "#9b9c9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.74,140.88h-5.85c.28-2,.57-3.92.85-5.88h17.62c-.43,2-.85,3.92-1.28,5.88h-5.43l-3.27,18.21H543.6Q545.16,150,546.74,140.88Z",
    fill: "#9b9c9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.56,162.33q-1.72,12.06-3.46,24.1h18.16l2.88-24.1Zm8.49,18-4.2-.07,1.65-13.32h4Q503.78,173.59,503.05,180.29Z",
    fill: "#9b9c9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.32,162.33q-1.72,12-3.46,24.09H441l2.88-24.09Zm8.49,17.95-4.2-.07,1.65-13.32h4Q435.54,173.58,434.81,180.28Z",
    fill: "#9b9c9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.81,159.05q2.08-12,4.16-24h12a5.34,5.34,0,0,1,3.49,1.35c1.61,1.57,1.45,3.91,1.3,5.9a7.25,7.25,0,0,1-1.5,4.66,6.26,6.26,0,0,1-2.91,1.88L501,159.05h-7c-.33-1.47-.64-3-.92-4.59-.5-2.88-.83-5.62-1-8.18l2.48.11a2.91,2.91,0,0,0,2.19-.72,3.15,3.15,0,0,0-.2-4.23,3.46,3.46,0,0,0-4.65,0q-1.44,8.79-2.86,17.59Z",
    fill: "#9b9c9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.9,186.37l4.17-24h12a5.3,5.3,0,0,1,3.48,1.36c1.62,1.57,1.45,3.91,1.31,5.89a7.38,7.38,0,0,1-1.5,4.67,6.37,6.37,0,0,1-2.92,1.88c.54,3.4,1.09,6.8,1.63,10.2h-7c-.34-1.46-.64-3-.92-4.58-.5-2.88-.84-5.62-1.05-8.18l2.49.11a2.93,2.93,0,0,0,2.18-.72,3.13,3.13,0,0,0-.2-4.23,3.46,3.46,0,0,0-4.65,0L450,186.37Z",
    fill: "#9b9c9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.14,186.42q1.27-12,2.56-24.09h8.14l-2,17.63h5l1.65-17.63H535q-1.43,12-2.86,24.09Z",
    fill: "#9b9c9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.83,186.36l35.25.06q1.44-12,2.87-24.09H414.2l-1.35,18H407.7q.92-9,1.81-18h-8.43q-.68,9-1.34,18H395l.94-18H387.7q-1.44,12-2.87,24",
    fill: "#9b9c9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.76,186.42q1.58-12,3.13-24.09H477l-.81,6.22,4.31-6.22h8.69L478.39,176l9.12,10.44-9.56-.06-4.06-6.15-1.14,6.21Z",
    fill: "#9b9c9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537,166.92l-.06-4.59h18.44L554,167l-4.87-.12L548,199.92l-5-4.12V166.86Z",
    fill: "#9b9c9d"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1b744b1b.svg";
export { ForwardRef as ReactComponent };